import React, { createContext, useContext, useState, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [courierId, setCourierId] = useState(() => localStorage.getItem('courier-id') || null);
  const [organizationId, setOrganizationId] = useState(() => localStorage.getItem('organization-id') || null);
  const [token, setToken] = useState(() => localStorage.getItem('courier-token') || null);

  const login = (tk, orgId) => {
    localStorage.setItem('courier-token', tk);
    localStorage.setItem('organization-id', orgId);
    setToken(tk);
    setOrganizationId(orgId);
  };

  const logout = () => {
    localStorage.removeItem('courier-token');
    localStorage.removeItem('organization-id');
    localStorage.removeItem('courier-id');
    setToken(null);
    setOrganizationId(null);
    setCourierId(null);
  };

  const isLoggedIn = Boolean(token && organizationId);

  return (
    <AuthContext.Provider value={{ courierId, organizationId, token, login, logout, isLoggedIn }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
